import { getSDK } from '../sdk.js'

// Fetch the current recipient's persisted notification rows
// (`root.notifs` — the notification-CENTER list, distinct from the
// transient toast queue on `root.notifications`/GlobalNotification).
// Backed by the SDK notifications entity (`workspaceProject.notifications`
// → the workspace-project worker /notifications routes); the governance
// Supabase notifications table was removed. Preserves the legacy
// `{ data, error }` envelope so callers stay contract-unchanged even though
// the dispatcher itself returns raw rows (or throws). Recipient scoping is
// enforced server-side by the authenticated token — takes no argument,
// mirroring the pre-existing shell copy this replaces byte-for-byte on that
// point (any `{ recipientEmail, limit }` a caller passes is intentionally
// unused, same as before).
//
// Local, self-contained copy — the canonical one, per `NotificationWrapper`'s
// own header comment in `../../components/Notifications.js`. It replaces a
// cross-package `@symbo-ls/workspace-shell/functions/notifications/collab/
// queries.js` read that frank always stubs to `""` on `smbls push` for a
// project (`shared`) that doesn't declare the shell as a library — a
// top-level barrel re-export never resolves through the declared-library
// resolver regardless of declaration (see FRANK-PAGES-BAG-1, tickets/done.md).
export const listNotifications = async () => {
  try {
    const rows = await getSDK().execute('workspaceProject.notifications', 'list')
    return { data: Array.isArray(rows) ? rows : rows?.data || [], error: null }
  } catch (error) {
    return { data: [], error }
  }
}
